import { ValidatorFn } from '@angular/forms';

export function conditionalValidator(predicate: () => boolean, validator: ValidatorFn, errorNamespace?: string): ValidatorFn {
  return (formControl => {
    if (!formControl.parent) {
      return null;
    }
    let error = null;
    if (predicate()) {
      error = validator(formControl);
    }
    if (errorNamespace && error) {
      // Define customError as a Record to allow string indexing
      const customError: Record<string, any> = {}; 
      customError[errorNamespace] = error;
      error = customError;
    }
    return error;
  });
}
